import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail } from 'lucide-react';
import PageWrapper from '../components/PageWrapper';

const ContactPage = () => {
  const navigate = useNavigate();

  return (
    <PageWrapper>
      <button 
        onClick={() => navigate(-1)} 
        className="back-btn"
        data-testid="back-btn"
      >
        ← Back
      </button>

      <article className="legal-page contact-page" data-testid="contact-page">
        <h1>Contact Us</h1>

        <div className="contact-content">
          <div className="contact-card">
            <Mail size={32} />
            <p>For questions, feedback, or support:</p>
            <a href="mailto:uro2go@gmail.com" className="contact-email">
              uro2go@gmail.com
            </a>
          </div>
        </div>
      </article>
    </PageWrapper>
  );
};

export default ContactPage;
